/* eslint-disable */
import React from 'react';
import classNames from 'classnames';
import { Tabs, Content, Icon, PopUp, Nav, Page } from '@beisen/chaos-ui';
import AreaItem from './AreaItem';
import PanelAreaShowList from './PanelAreaShowList';
import {
    ifHidePopupNav,
    generateHeaderConfig,
    clearHeaderConfig
} from '../../util/helper';
import * as findPath from './findAreaPath';
import _uniq from 'lodash/uniq';
require('./PanelArea.scss');
import * as areaHelp from './getAreaData';
import transLoader from '@beisen/i18n-translation-loader';
import { addEnNavClassName } from '../../util/ui';

const defaultTranslation = {
    clear: '清空',
    save: '保存',
    country: '全国',
    global: '全球',
    chooseAreaTip: '请在下方选择地区'
}

const firstLine = {
    1: {
        0: {
            1: {
                Name: '全国',
                isFilter: true
            },
            2: {
                Name: '国内全部地区',
                isFilter: true
            }
        },
        1: {
            1: {
                Name: '全省',
                isFilter: true
            },
            2: {
                Name: '省内全部地区',
                isFilter: true
            }
        },
        2: {
            2: {
                Name: '市内全部地区',
                isFilter: true
            }
        }
    },
    2: {
        0: {
            1: {
                Name: '全球',
                isFilter: true
            },
            2: {
                Name: '全球全部地区',
                isFilter: true
            }
        },
        1: {
            1: {
                Name: '全国',
                isFilter: true
            },
            2: {
                Name: '该国全部地区',
                isFilter: true
            }
        },
        2: {
            2: {
                Name: '该省全部地区',
                isFilter: true
            }
        }
    }
};
// 仅有二级子地区的省市 - 北上津重港澳台 - 其他 - 阿尔巴尼亚
const ONLY_SEC_CHILD_AREA = ['1100', '3100', '1200', '5000', '8100', '8200', '7100', '9000', '255'];
export default class PanelArea extends React.Component {
    constructor(props) {
        super(props);
        this.allArea = {};
        this.handleCancel = this.handleCancel.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.touchArea = this.touchArea.bind(this);
        this.changeTab = this.changeTab.bind(this);
        this.deleteSelectArea = this.deleteSelectArea.bind(this);
        this.clearSelectedList = this.clearSelectedList.bind(this);
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            clear: 'common.clear',
            save: 'common.save',
            country: 'area.country',
            global: 'area.global',
            chooseAreaTip: 'area.chooseAreaTip'
        }), props.translation);
        this.state = {
            initAllData: [],
            activeTab: '1',
            selectAreas: this.props.selectedAreas,
            expandIds: {
                level1: {
                    1: '1',
                    2: '2'
                },
                level2: {
                    1: 'first',
                    2: 'first'
                }
            },
            selectIds: this.props.selectIds,
            showLevel: {
                1: {
                    showLevel2: [{
                        Id: '1',
                        Level: '0',
                        Pid: '',
                        Name: this.translation.country
                    }],
                    showLevel3: [{
                        Id: '1',
                        Level: '0',
                        Pid: '',
                        Name: this.translation.country
                    }]
                },
                2: {
                    showLevel2: [{
                        Id: '2',
                        Level: '0',
                        Pid: '',
                        Name: this.translation.global
                    }],
                    showLevel3: [{
                        Id: '2',
                        Level: '0',
                        Pid: '',
                        Name: this.translation.global
                    }]
                }
            }
        };

    }
    componentWillMount() {
        const langMap = {
          zh_CN: 'chs',
          zh_TW: 'cht',
          en_US: 'en'
        }
        const translationParams = {
          lang: langMap[areaHelp.getCurrentLang()],
          tenantId: areaHelp.getTenantID()
        };
        const { lang, tenantId } = translationParams;
        areaHelp.getAreaVersion().then(version => {
            areaHelp.getLocationData(lang, version, tenantId).then(AreaCode => {
                const PopAreaData = this.initState(AreaCode);
                this.setState({
                    initAllData: PopAreaData
                });
            })
        })
    }
    componentDidMount() {
        if (ifHidePopupNav() && this.props.pop_type !== 'searchList') {
            this.registCallback();
            this.setBoxHeader();
        }
    }
    componentWillUnmount() {
        if (ifHidePopupNav() && this.props.pop_type !== 'searchList') {
            this.clearCallback();
            this.getPreHeaderConfig();
        }
    }
    //注册壳子回调函数
    registCallback() {
        if (!this.props.singleSelect) {
            window.globalEventManager[
                'panelAreaSubmit'
            ] = this.handleConfirm.bind(this);
        }
        window.globalEventManager['panelAreaBack'] = this.handleCancel.bind(
            this
        );
    }
    //清除壳子回调函数
    clearCallback() {
        if (!this.props.singleSelect) {
            delete window.globalEventManager['panelAreaSubmit'];
        }
        delete window.globalEventManager['panelAreaBack'];
    }
    ////组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
    getPreHeaderConfig() {
        clearHeaderConfig();
    }
    //设置壳子的导航
    setBoxHeader() {
        let singleSelect = this.props.singleSelect;
        const { translation } = this;
        const rightText = translation.save;
        generateHeaderConfig(function (headerConfig, setButton) {
            let config = Object.assign({}, headerConfig)
            const left_item = [
                {
                    callback: 'panelAreaBack',
                    control: true,
                    text: '',
                    type: 'back'
                }
            ];
            config = setButton('left', left_item, config);
            if (!singleSelect) {
                const right_item = [
                    {
                        icon: '',
                        callback: 'panelAreaSubmit',
                        control: true,
                        text: rightText,
                        type: 'text'
                    }
                ];
                config = setButton('right', right_item, config);
            }
            config.titleItem = {
                text: '',
                icon: '',
                callback: '',
                control: false
            };
            return config;
        });
    }
    //数据转换 将子对象转化为数组
    transChildToArray(level, pid, data, rootId) {
        const {translation} = this;
        if (typeof data[0] == 'string' && typeof data == 'object') {
            let rData = this.allArea[rootId][level + 1];
            if (level == 0 && !rData) {
                if (pid == '1') {
                    rData = [{
                        Id: '1',
                        Level: '0',
                        Pid: '',
                        Name: translation.country,
                        isFilter: false
                    }];
                } else {
                    rData = [{
                        Id: '2',
                        Level: '0',
                        Pid: '',
                        Name: translation.global,
                        isFilter: false
                    }];
                }
            }
            let item = {
                Id: data[0],
                Name: data[1],
                Level: level + 1,
                Pid: pid
            };
            if (!rData) {
                this.allArea[rootId][level + 1] = [item];
            } else {
                this.allArea[rootId][level + 1] = rData.concat([item]);
            }
            if (data.length > 2) {
                this.transChildToArray(level + 1, data[0], data[2], rootId);
            }
        }
        if (typeof data[0] == 'object' && typeof data == 'object') {
            data.forEach(dataItem => {
                this.transChildToArray(level, pid, dataItem, rootId);
            });
        }
    }
    //数据转换 初始化对象
    initState(data) {
        const { showForeignSource = false } = this.props;
        data.forEach((item, index) => {
            // 不显示国外数据
            if (!showForeignSource && index == 1) return;
            if (index == 0 || index == 1) {
                this.allArea[item[0]] = {};
                this.allArea[item[0]][0] = [
                    {
                        Id: item[0],
                        Name: item[1],
                        Level: 0,
                        Pid: ''
                    }
                ];
                if (item.length > 2) {
                    this.transChildToArray(0, item[0], item[2], item[0]);
                }
            } else {
                this.transChildToArray(0, '1', item, '1');
            }
        });
        return data;
    }
    //点击取消
    handleCancel(e) {
        e && e.preventDefault && e.preventDefault();
        this.props.handleCancel && this.props.handleCancel();
    }
    //点击确定
    handleConfirm(event) {
        event && event.preventDefault && event.preventDefault();
        let { selectAreas } = this.state;
        let { handleConfirm, singleSelect } = this.props;
        if (singleSelect) {
            selectAreas = [selectAreas[selectAreas.length - 1]];
        }
        handleConfirm && handleConfirm(selectAreas);
    }
    touchArea(item) {
        this.hasClear = false;
        let { singleSelect } = this.props;
        let {
            showLevel,
            activeTab,
            selectIds,
            selectAreas,
            expandIds,
            initAllData
        } = this.state;
        let isFullPathFormat = this.props.isFullPathFormat || '';
        //数据显示
        let childAreas = [];
        if (item.dataLevel != 3) {
            // 覆盖记录每个层级展开的Item
            expandIds['level' + item.dataLevel][activeTab] = item.Id;
            const childAreasData = this.allArea[activeTab][
                parseInt(item.Level) + 1
            ];
            if (childAreasData) {
                childAreas = childAreasData.filter(dataItem => {
                    return dataItem.Pid == item.Id;
                });
            }
            firstLine[activeTab][item.Level][2] = item;
            showLevel[activeTab].showLevel3 = [
                firstLine[activeTab][item.Level][2]
            ];
            if (item.dataLevel == 1) {
                firstLine[activeTab][item.Level][1] = item;
                // 没有三级节点及全国
                if (item.Pid == '' || ONLY_SEC_CHILD_AREA.includes(item.Id)) {
                    showLevel[activeTab].showLevel2 = [
                        firstLine[activeTab][item.Level][1]
                    ];
                    if (item.Pid == '') {
                        showLevel[activeTab].showLevel3 = [item];
                    } else {
                        showLevel[activeTab].showLevel3 = [item].concat(
                            childAreas
                        );
                    }
                } else {
                    showLevel[activeTab].showLevel2 = [
                        firstLine[activeTab][item.Level][1]
                    ].concat(childAreas);
                    showLevel[activeTab].showLevel3 = [item];
                }
            } else if (item.dataLevel == 2) {
                // 点击第一个节点且第一个节点不在OSCA内，仅渲染一个本身一个
                if (
                    item.dataIndex === 0 &&
                    !ONLY_SEC_CHILD_AREA.includes(item.Id)
                ) {
                    showLevel[activeTab].showLevel3 = [item];
                } else {
                    showLevel[activeTab].showLevel3 = showLevel[
                        activeTab
                    ].showLevel3.concat(childAreas);
                }
            }
        } else {
            if (singleSelect) {
                // 单选
                if (selectAreas[0] && selectAreas[0].Id == item.Id) {
                    // 如果已经选中,则取消选中
                    selectAreas = [];
                    selectIds = '';
                } else {
                    if (isFullPathFormat) {
                        let Area = findPath.findAreaPath(initAllData, item.Id)
                            .Area;
                        item.Name =
                            typeof Area == 'string'
                                ? Area
                                : _uniq(Area).join('/');      // 全路径省市用/格开
                    }
                    this.props.handleConfirm &&
                        this.props.handleConfirm([item]);
                    return;
                }
            } else {
                // 多选
                if (
                    selectIds.indexOf(item.Id + ',') >= 0 ||
                    (selectIds.length > 0 && selectIds.indexOf(',') < 0)
                ) {
                    selectIds = selectIds
                        .replace(',' + item.Id, '')
                        .replace(item.Id + '', '');
                    selectAreas = selectAreas.filter(areaItem => {
                        return areaItem.Id !== item.Id;
                    });
                    this.setState({
                        selectAreas,
                        selectIds
                    });
                    return;
                }
                const childItemIds = [],
                    thridItemIds = [];
                let parentItem = [];
                // 如果Level为1获取子集的子集ID集合后 去除
                if (item.Level === 1) {
                    this.allArea[activeTab][2].map(areaItem => {
                        if (areaItem.Pid === item.Id) {
                            childItemIds.push(areaItem.Id);
                        }
                    });
                    const thirdActiveTabAreas = this.allArea[activeTab][3];
                    if (thirdActiveTabAreas) {
                        thirdActiveTabAreas.map(areaItem => {
                            if (childItemIds.includes(areaItem.Pid)) {
                                thridItemIds.push(areaItem.Id);
                            }
                        });
                    }
                }
                // 获取当前Item父级的父级ID 如果有 去除
                if (item.Level === 3) {
                    parentItem = this.allArea[activeTab][2].filter(areaItem => {
                        return areaItem.Id === item.Pid;
                    })[0];
                }
                // 过滤重复点选的 过滤顶级的 过滤父子节点重复的 过滤有可能存在的孙子节点的
                selectAreas = selectAreas.filter(areaItem => {
                    return !(
                        (item.Level === '0'
                            ? areaItem.Id !== activeTab
                            : areaItem.Level === '0') ||
                        areaItem.Pid === item.Id ||
                        areaItem.Id === item.Pid ||
                        thridItemIds.includes(areaItem.Id) ||
                        areaItem.Id === parentItem.Pid
                    );
                });
                selectAreas.push(item);
            }
        }
        // 过滤出需要选中的ID
        selectAreas.forEach((dataItem, index) => {
            if (index == 0) {
                selectIds = dataItem.Id + ',';
            } else {
                selectIds = selectIds + dataItem.Id + ',';
            }
        });
        //全路径展示
        if (isFullPathFormat) {
            selectAreas.forEach((dataItem, index) => {
                let Area = findPath.findAreaPath(initAllData, dataItem.Id).Area;
                dataItem.Name = typeof Area == 'string' ? Area : _uniq(Area).join('/');  // 全路径省市用空格格开
            });
        }
        this.setState({
            showLevel,
            selectAreas,
            selectIds,
            expandIds
        });
    }
    //改变tab
    changeTab(key) {
        this.setState({
            activeTab: key
        });
    }
    deleteSelectArea(itemId) {
        let selectAreas = this.state.selectAreas.filter(
            areaItem => areaItem.Id != itemId
        );
        let selectIds = '';
        // 过滤出需要选中的ID
        selectAreas.forEach((dataItem, index) => {
            if (index == 0) {
                selectIds = dataItem.Id + ',';
            } else {
                selectIds = selectIds + dataItem.Id + ',';
            }
        });
        this.setState({
            selectAreas,
            selectIds
        });
    }
    // 点击清空清除所有所选项
    clearSelectedList(e) {
        e.preventDefault();
        this.hasClear = true;
        this.setState({
            selectAreas: [],
            selectIds: ''
        });
        if (this.props.singleSelect) {
            this.props.handleConfirm && this.props.handleConfirm([]);
        }
    }

    getAllTabs() {
        let allData = this.allArea;
        const {translation} = this;
        let { activeTab, showLevel, initAllData } = this.state;
        const self = this;
        const enNavButtonClass = addEnNavClassName();
        return Object.keys(allData).map((item, index) => {
            return (
                <div
                    title={allData[item][0][0].Name}
                    tabKey={item}
                    data-key={item}
                    key={'p' + index}
                >
                    <Content>
                        {this.props.singleSelect ? null : (
                            <div className="area-selected">
                                <PanelAreaShowList
                                    selectAreas={this.state.selectAreas}
                                    deleteSelectArea={this.deleteSelectArea}
                                    translation={this.translation}
                                />
                                <div className="area-search" />
                            </div>
                        )}
                        <div
                            className="area-list"
                            style={
                                this.props.singleSelect
                                    ? { height: window.innerHeight - 44 }
                                    : { height: window.innerHeight - 88 }
                            }
                        >
                            <div className="level-1">
                                <div
                                    className={classNames(
                                        'clearSelectedListBtn',
                                        enNavButtonClass,
                                        { active: this.hasClear }
                                    )}
                                    onTouchTap={this.clearSelectedList}
                                >
                                    －{translation.clear}－
                                </div>
                                {allData[item][1].map((level1, index) => {
                                    return (
                                        <AreaItem
                                            key={'level1' + index}
                                            {...level1}
                                            selectAreas={this.state.selectAreas}
                                            selectIds={this.state.selectIds}
                                            dataLevel="1"
                                            initAllData={initAllData}
                                            onTouchTap={this.touchArea}
                                            expandIds={
                                                this.state.expandIds['level1'][
                                                    activeTab
                                                ]
                                            }
                                            singleSelect={
                                                this.props.singleSelect
                                            }
                                            hasClear={this.hasClear}
                                        />
                                    );
                                })}
                            </div>
                            <div className="level-2 border-r">
                                {' '}
                                {this.hasClear
                                    ? null
                                    : showLevel[item].showLevel2.map(
                                          (level2, index) => {
                                              return (
                                                  <AreaItem
                                                      key={'level2' + index}
                                                      {...level2}
                                                      selectAreas={
                                                          this.state.selectAreas
                                                      }
                                                      selectIds={
                                                          this.state.selectIds
                                                      }
                                                      dataLevel="2"
                                                      onTouchTap={
                                                          this.touchArea
                                                      }
                                                      initAllData={initAllData}
                                                      expandIds={
                                                          this.state.expandIds[
                                                              'level2'
                                                          ][activeTab]
                                                      }
                                                      dataIndex={index}
                                                      singleSelect={
                                                          this.props
                                                              .singleSelect
                                                      }
                                                      hasClear={this.hasClear}
                                                  />
                                              );
                                          }
                                      )}{' '}
                            </div>
                            <div className="level-3">
                                {' '}
                                {this.hasClear
                                    ? null
                                    : showLevel[item].showLevel3.map(
                                          (level3, index) => {
                                              return (
                                                  <AreaItem
                                                      key={'level3' + index}
                                                      {...level3}
                                                      selectAreas={
                                                          this.state.selectAreas
                                                      }
                                                      selectIds={
                                                          this.state.selectIds
                                                      }
                                                      dataLevel="3"
                                                      initAllData={initAllData}
                                                      onTouchTap={
                                                          this.touchArea
                                                      }
                                                      expandIds={0}
                                                      singleSelect={
                                                          this.props
                                                              .singleSelect
                                                      }
                                                      hasClear={this.hasClear}
                                                  />
                                              );
                                          }
                                      )}{' '}
                            </div>
                        </div>
                    </Content>
                </div>
            );
        });
    }
    render() {
        const style = this.props.pop_type == 'searchList' ? { width: '85%', left: '15%' } : {};
        const animation = this.props.pop_type == 'searchList' ? 'right-slide-fade' : 'bottom-slide-fade';
        const { translation } = this;
        const enNavButtonClass = addEnNavClassName();
        let NavItems = [
            <div
                role="left"
                href="javascript:;"
                onTouchTap={this.handleCancel}
            >
                <Icon icon='m-sys-backward' />
            </div>,
            (this.props.singleSelect ? null : <a role='right' href='javascript:;' className={classNames('area-submit', enNavButtonClass)} onTouchTap={this.handleConfirm}>{translation.save}</a>)
        ];
        let navStyle =
            ifHidePopupNav() && this.props.pop_type !== 'searchList'
                ? { display: 'none' }
                : {};
        return (
            <PopUp
                visible={this.props.visible}
                animation={animation}
                maskAnimation="fade"
                cls="poparea-popup"
                style={style}
                onClose={this.handleCancel}
                afterClose={this.props.afterClose}
            >
                <Page>
                    <Nav style={navStyle}>{NavItems}</Nav>
                    <Tabs
                        defaultKey="1"
                        changeTab={this.changeTab}
                        cls="detail-page"
                        swipe={false}
                    >
                        {this.getAllTabs()}
                    </Tabs>
                </Page>
            </PopUp>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Field_Components/PopArea/PanelArea.js